export function formatBrDateToIso(date?: string): string | undefined {
  if (typeof date !== 'string') return undefined
  const trimmed = date.trim()
  const [day, month, year] = trimmed.split('/')
  if (!day || !month || !year) return undefined
  const dayNum = Number(day)
  const monthNum = Number(month)
  const yearNum = Number(year)
  if (
    !Number.isInteger(dayNum) ||
    !Number.isInteger(monthNum) ||
    !Number.isInteger(yearNum) ||
    dayNum < 1 ||
    monthNum < 1 ||
    monthNum > 12 ||
    yearNum < 1000
  ) {
    return undefined
  }
  const dateObj = new Date(yearNum, monthNum - 1, dayNum)
  if (
    dateObj.getFullYear() !== yearNum ||
    dateObj.getMonth() !== monthNum - 1 ||
    dateObj.getDate() !== dayNum
  ) {
    return undefined
  }
  return dateObj.toISOString().slice(0, 10)
}
